import { request } from "@/utils/requestUtils";
import type {
  CityInfo,
  OSSConfig,
  PrefixPhone,
  Country,
  EnumItem,
} from "./type";

export async function getOssConfigApi() {
  return request<OSSConfig>({
    service: "oam-admin",
    url: "/oss/signature/get",
    method: "POST",
    data: { dir: "/" },
  });
}

export async function getCitysByCountryApi(data: any) {
  return request<CityInfo[]>({
    service: "oam-admin",
    url: "/city/find_country_area_list",
    method: "POST",
    params: data,
  });
}

export async function checkIsLastLevelCityApi(data: any) {
  return request({
    service: "oam-admin",
    url: "/city/check_city_is_last_level",
    method: "POST",
    params: data,
  });
}

// 查询省市区数据
export async function getCityList() {
  return request<CityInfo[]>({
    service: "oam-admin",
    url: "/city/find_area_list",
    method: "POST",
  });
}

// 阿里云数据结构化
export async function aliGetAlgorithmResult(params: any) {
  return request<string>({
    service: "oam-admin",
    url: "/ali/getExtractExpressInfo",
    method: "POST",
    params,
  });
}

export async function getPhonePrefixApi() {
  return request<PrefixPhone[]>({
    service: "oam-admin",
    url: "/api/country_enum/query_country_phone_prefix",
    method: "POST",
    params: {},
  });
}

export async function checkCity(data) {
  return request<{ model: boolean }>({
    service: "oam-admin",
    url: "/city/check_city_is_last_level",
    method: "POST",
    params: data,
  });
}

export async function getEnumApi() {
  return request<Record<string, EnumItem[]>>({
    service: "oam-admin",
    url: "/enum/query",
    method: "POST",
    data: {},
  });
}

export async function getCountrysApi(params: any) {
  return request<Country[]>({
    service: "oam-admin",
    url: "/country/query",
    method: "POST",
    data: params,
  });
}
